module.exports = __webpack_public_path__ + "static/media/bg_bottom.76115c57.svg";